import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { ContactForm } from "~/components/ContactForm/ContactForm"
import { Layout } from "~/components/Layout/Layout"

import { Content } from "./components/Content/Content"

const Faq: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={t("page.faq")}>
      <div className="container">
        <Breadcrumbs />
        <Content />
      </div>

      <ContactForm
        content={() => (
          <>
            {/* hidden by #5 */}
            {/*<div dangerouslySetInnerHTML={{ __html: t("faq.BlueForm.Content") }} />*/}
            <div />
            <div className="d-none d-sm-block" />
          </>
        )}
        title={t("faq.BlueForm.Title")}
        showMobileText
      />
    </Layout>
  )
}

export default Faq
